var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgSendAirplane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.282 0.722593C28.9581 0.400245 28.5519 0.173635 28.108 0.0676694C27.664 -0.0382967 27.1995 -0.0195175 26.7655 0.121943L1.7205 8.49672C1.25601 8.64426 0.845559 8.92649 0.540982 9.30776C0.236405 9.68902 0.0513653 10.1522 0.00923426 10.6388C-0.0328967 11.1255 0.0697704 11.6137 0.304269 12.0419C0.538768 12.47 0.894579 12.8189 1.32676 13.0445L11.718 18.1929L16.8536 28.6442C17.0601 29.0533 17.3759 29.3968 17.7659 29.6362C18.1559 29.8756 18.6047 30.0016 19.062 30H19.2332C19.7229 29.9638 20.1905 29.7808 20.5752 29.4748C20.9599 29.1687 21.2438 28.7538 21.3902 28.2838L29.864 3.24532C30.0153 2.81274 30.041 2.34596 29.9379 1.89935C29.8349 1.45273 29.6074 1.04464 29.282 0.722593ZM2.78187 10.865L24.6427 3.55423L12.5054 15.7217L2.78187 10.865ZM19.1818 27.2885L14.32 17.5408L26.4574 5.37334L19.1818 27.2885Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendAirplane);
export default __webpack_public_path__ + "static/media/sendAirplane.5ffebd2ff9e1a7b2340e28d1715ed55b.svg";
export { ForwardRef as ReactComponent };